import api from '../index'

export interface AiTool {
  id: number
  intent_code: string
  intent_name: string
  description: string
  keywords: string[] | string
  required_entities: string[] | string
  action_class: string
  need_confirm: 0 | 1
  is_enabled: 0 | 1
  sort: number
  created_at: string
  updated_at: string
}

export interface AiToolListParams {
  page?: number
  page_size?: number
  keyword?: string
  is_enabled?: 0 | 1
  need_confirm?: 0 | 1
}

export interface AiToolUpdateData {
  intent_name: string
  description: string
  keywords: string[]
  is_enabled: 0 | 1
  need_confirm: 0 | 1
  sort: number
}

export const aiApi = {
  // 获取 AI 工具列表
  list: (params?: AiToolListParams) => api.get('ai/tool/list', { params }),

  // 获取 AI 工具详情
  detail: (id: number) => api.get(`ai/tool/${id}`),

  // 更新 AI 工具
  update: (id: number, data: AiToolUpdateData) => api.put(`ai/tool/${id}`, data),
}

export default aiApi
